// Redaktionsstand, keine automatische Versionsabfrage beim Seitenaufruf.
// Abgeglichen mit dem veröffentlichten Web-/Android-Build und dem App-Repository.
export const appRelease = {
  version: "1.8.3",
  build: 197,
  checkedAt: "10.09.2026",
};

export const roleHighlights = [
  {
    id: "familien",
    label: "Für Familien",
    headline: "Wissen, was ansteht. Direkt erledigen.",
    intro: "Der Bereich Familie & Team bündelt die Organisation rund um deine Kinder – mit passenden Aufgaben und kurzen Wegen.",
    items: [
      { title: "Einmal abwesend melden", copy: "Zeiträume und auf Wunsch wiederkehrende Wochentage hinterlegen. Die Abwesenheit berücksichtigt auch passende Termine, die später dazukommen.", tag: "Abwesenheiten" },
      { title: "Zusammen zum Spiel", copy: "Freie Plätze direkt für dich und deine Kinder buchen. Eine gemeinsame Buchung bleibt in einem Auto; bei Absagen werden Plätze wieder frei.", tag: "Direkte Mitfahrbuchung" },
      { title: "Weniger nachfragen", copy: "Rückmeldungen, Aufgaben, Einwilligungen und Umfragen mit Fristen im Blick behalten. Der Familien-Assistent führt zur passenden Aktion.", tag: "Familien-Assistent" },
    ],
  },
  {
    id: "trainer",
    label: "Für das Trainerteam",
    headline: "Mehr Überblick. Mehr Zeit fürs Team.",
    intro: "Von der ersten Trainingsidee bis zum Schlusspfiff: Planung, Organisation und Entwicklung greifen ineinander.",
    items: [
      { title: "Entwicklung sichtbar machen", copy: "Bis zu drei aktive Lernziele je Kind begleiten. Beobachtungen, Anwesenheiten und abgeschlossene Spiele im Verlauf zusammenführen; Familien sehen freigegebene Inhalte.", tag: "Lernziele & Verlauf" },
      { title: "Den Spieltag vorbereiten", copy: "Offene Punkte im kompakten Autopilot erkennen, die Spielform je Spiel wählen und Gastspieler auch aus anderen Jugenden nominieren. Du behältst die Entscheidung.", tag: "Spieltag & Kader" },
      { title: "Auf dem Platz startklar", copy: "Die Spieltagsübersicht als PDF mitnehmen, geplante und erfasste Einsatzminuten unterscheiden und abgeschlossene Spiele im Verlauf auswerten.", tag: "PDF & Spielhistorie" },
    ],
  },
  {
    id: "verein",
    label: "Für den Verein",
    headline: "Alle einbinden. Klar organisiert.",
    intro: "Zugänge, Abstimmungen und Saisonwechsel bleiben nachvollziehbar – mit den passenden Rollen und Freigaben.",
    items: [
      { title: "Einladen statt erklären", copy: "Team-Einladungen als Link oder QR-Code teilen, mit Ablaufdatum und Widerruf. Bestehende Konten können weitere Teams anfragen; Freigaben und Kinderzuordnung bleiben getrennt.", tag: "Team-Einladungen" },
      { title: "Gemeinsam entscheiden", copy: "Einfach- oder Mehrfachauswahl, Fristen und passende Zielgruppen festlegen. Je nach Umfrage zählt eine Stimme pro Person, Familie oder Kind.", tag: "Umfragen" },
      { title: "Gut in die neue Saison", copy: "Beim Saisonwechsel gezielt Daten übernehmen, Familienzuordnungen erhalten und aktive Lernziele oder Abwesenheiten bei Bedarf mitnehmen.", tag: "Saisonübergang" },
    ],
  },
];
